import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Flame } from "lucide-react";
import { api, readTime } from "../../lib/api";
import { Reveal } from "../Reveal";
import { Badge } from "../Pill";

const fmt = (n) => (n >= 1e6 ? (n / 1e6).toFixed(1) + "M" : n >= 1e3 ? (n / 1e3).toFixed(1) + "K" : String(n));

export default function TrendingStrip() {
  const [stories, setStories] = useState([]);

  useEffect(() => {
    api("/trending?limit=6").then(setStories).catch(() => {});
  }, []);

  if (!stories.length) return null;

  return (
    <section data-testid="trending-section" className="bg-ink text-cream py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <Reveal>
              <Badge tone="gold">
                <Flame size={11} /> Most Read This Week
              </Badge>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-6 font-display uppercase text-4xl md:text-5xl lg:text-6xl leading-[0.98]">
                What India is reading
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.2}>
            <p className="max-w-sm text-cream/50 leading-relaxed">
              The stories our readers could not put down this week, ranked by real views across the site.
            </p>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-2 gap-x-12">
          {stories.map((b, i) => (
            <Reveal key={b.id} delay={0.05 * i}>
              <Link
                to={`/edit/${b.slug}`}
                data-testid={`trending-story-${b.slug}`}
                className="group flex items-center gap-6 py-7 border-b border-cream/10 first:border-t"
              >
                <span className="font-display text-5xl md:text-6xl text-champagne/90 w-16 shrink-0 group-hover:text-champagne transition-colors duration-300">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div className="flex-1 min-w-0">
                  <p className="text-[9px] font-bold uppercase tracking-[0.25em] text-rose">{b.category}</p>
                  <h3 className="mt-2 font-display uppercase text-xl md:text-2xl leading-tight text-cream group-hover:text-champagne transition-colors duration-300">
                    {b.title}
                  </h3>
                  <p className="mt-2 text-[10px] font-bold uppercase tracking-[0.2em] text-cream/40">
                    {fmt(b.weekly_views)} reads this week · {readTime(b.content)} min · {b.author}
                  </p>
                </div>
                <div className="w-16 h-16 md:w-20 md:h-20 shrink-0 overflow-hidden rounded-2xl hidden sm:block">
                  <img
                    src={b.cover_image}
                    alt={b.title}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-110"
                  />
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
